import { Download, Share2 } from "lucide-react";

export default function PublicShareBar({ onShare, onDownloadPDF, downloading }) {
  return (
    <div className="fixed bottom-0 inset-x-0 z-40 backdrop-blur-xl bg-[#0A0C10]/90 border-t border-white/5">
      <div className="max-w-2xl mx-auto px-4 pr-28 sm:pr-4 py-3.5 flex items-center gap-3">
        <button
          onClick={onShare}
          className="btn-ghost flex-1 flex items-center justify-center gap-2"
          data-testid="public-share-btn"
        >
          <Share2 size={16} /> Share
        </button>
        <button
          onClick={onDownloadPDF}
          disabled={downloading}
          className="btn-primary flex-1 flex items-center justify-center gap-2 disabled:opacity-60"
          data-testid="public-download-btn"
        >
          <Download size={16} /> {downloading ? "Generating…" : "Download PDF"}
        </button>
      </div>
    </div>
  );
}
